// extracted by mini-css-extract-plugin
export default {"bookmarks-page":"styles_bookmarks-page__pKk9C","bookmarksPage":"styles_bookmarks-page__pKk9C","bookmark-tab":"styles_bookmark-tab__D7jIu","bookmarkTab":"styles_bookmark-tab__D7jIu"};